import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = t((a, r) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: r,
    ...a,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M9 2a1 1 0 0 1 1 1v4h1V6a1 1 0 0 1 1-1 4 4 0 0 1 4 4v2a1 1 0 0 1-1 1h-1a2 2 0 1 1-4 0H6a2 2 0 1 1-4 0H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
          }
        )
      }
    )
  }
));
i.displayName = "TruckIcon";
export {
  i as TruckIcon,
  i as default
};
//# sourceMappingURL=index.js.map
